<template>
	<LineChart
		:chart-data="chartData"
		:chart-options="chartOptions"
		:loading="isLoading"
		:error="loadError"
		@retry="loadProcessCumulativeCounts"
	/>
</template>

<script>
import LineChart from '../../../../../../shared/components/chart/line-chart.vue'
import { getProcessCountsCumulative } from '../../../../../../shared/utils/api/processing.js'

export default {
	components: { LineChart },
	props: {
		chartApiParams: Object,
		dateFrom: String,
		dateTo: String
	},
	data () {
		return {
			processesChartData: [],
			// Starts true because created() fetches immediately.
			isLoading: true,
			loadError: null,
			chartOptions: {
				responsive: true,
				maintainAspectRatio: false
			}
		}
	},
	computed: {
		borderColor () {
			const resolved = getComputedStyle(document.documentElement)
				.getPropertyValue('--global-syrenis-black')
				.trim()
			return resolved || '#242529'
		},
		chartData () {
			const data = []
			const labels = []
			this.processesChartData?.forEach(process => {
				const [label, value] = Object.entries(process).flat()
				data.push(value)
				labels.push(label)
			})
			return {
				labels,
				datasets: [
					{
						borderColor: this.borderColor,
						data
					}
				]
			}
		},
		displayChart () {
			return !!this.chartData.datasets[0].data.length
		}
	},
	watch: {
		chartApiParams () {
			this.loadProcessCumulativeCounts()
		}
	},
	async created () {
		this.loadProcessCumulativeCounts()
	},
	methods: {
		async loadProcessCumulativeCounts () {
			this.isLoading = true
			this.loadError = null
			// Ask the parent to reveal the column now rather than after the
			// fetch. It gates on this event, so without it the chart's loading
			// state is never visible on first mount.
			this.$emit('chart-data', true)
			try {
				if (this.chartApiParams.processes) {
					const { data: { processCounts } } = await getProcessCountsCumulative(this.chartApiParams.processes, this.chartApiParams.dateFrom, this.chartApiParams.dateTo)
					this.processesChartData = processCounts
				}
			} catch (error) {
				this.loadError = error
			} finally {
				this.isLoading = false
				// The parent hides this whole column when we report no data,
				// which is existing deliberate behaviour and stays. But a
				// failed load must not vanish the same way, or the user cannot
				// tell "nothing to show" from "this broke". Ask to be shown on
				// error so the chart's own error state is reachable.
				this.$emit('chart-data', this.displayChart || !!this.loadError)
			}
		}
	}
}
</script>
